import { APIcallerv2 } from './APIcaller';

export const getTransferLists = () => APIcallerv2.apiGet(`/transfers/list`);

export const setToInvoiced = (transferListIds) =>
  APIcallerv2.apiPost(`/transfers/set-to-invoiced`, { transferListIds });

export const setToDraft = (transferListIds) =>
  APIcallerv2.apiPost(`/transfers/set-to-draft`, { transferListIds });

export const cancelReception = (transferListIds) =>
  APIcallerv2.apiPost(`/transfers/cancel-reception`, { transferListIds });

export const cancelSend = (transferListIds) =>
  APIcallerv2.apiPost(`/transfers/cancel-send`, { transferListIds });

export const deleteTransfer = (transferListId) =>
  APIcallerv2.apiDelete(`/transfers/${transferListId}/delete`);

export const exportTransferLists = (transferListIds) =>
  APIcallerv2.apiPost(`/transfers/export`, { transferListIds });

export const exportContent = (transferListIds) =>
  APIcallerv2.apiPost('/transfers/export/content', { transferListIds });

export const downloadBatchCreationFileTemplate = (storeIds) =>
  APIcallerv2.apiPost('/transfers/batch-creation-file-template', { storeIds }, 'blob');

export const validateBatchCreationFile = (transfers) =>
  APIcallerv2.apiPost('/transfers/batch-creation/validate', transfers, 'blob');

export const importBatchCreation = (transfers) =>
  APIcallerv2.apiPost('/transfers/batch-creation/import', transfers);

export default {
  getTransferLists,
  setToInvoiced,
  setToDraft,
  cancelReception,
  cancelSend,
  deleteTransfer,
  exportTransferLists,
  exportContent,
  downloadBatchCreationFileTemplate,
  validateBatchCreationFile,
  importBatchCreation,
};
